import React from 'react';
import { steps } from '../data/liikunta';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-178" data-mp="7svcwdog1st2">
      <div className="mx-auto max-w-6xl" data-id="element-179" data-mp="3pyroqzddcubm">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-180" data-mp="3pzt8ds8gap4y">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-181" data-mp="3tzjxzsm8qz7w">
            Näin <em className="text-red-700" style={{
            hyphens: 'manual'
          }} data-id="element-182" data-mp="lll20qz9rdue">LIIKUNTA VALMIS™</em> toimii
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-183" data-mp="qila17foiqo5">
            Latauksesta liikuntasaliin: valmistele seuraava tunti vain viidessä minuutissa.
          </p>
        </div>
        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-184" data-mp="grqns32fnr2p">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-185" data-mp="14h1h4zhgej6t" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-186" data-mp="19b5p9m2ggx9h">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-187" data-mp="2mnco1261ocfn">
                <span className="sr-only" data-id="element-188" data-mp="31b7k8sj9gyxh">Vaihe {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-189" data-mp="2wkhbr6fjgfyk">{step.text}</p>
            </li>)}
        </ol>
        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-190" data-mp="3ab4d76coojyc">
          Avaa → valitse → valmistaudu → opeta. Helppoa ja selkeää.
        </p>
      </div>
    </section>;
}